<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.internal.places.title') }}</h1>
      <i-button
        type="primary"
        size="medium"
        @click="isAddPlaceDialogOpen = true"
      >
        <icon-plus class="tw-mr-2" />
        {{ $t('adm.internal.places.create_button') }}
      </i-button>
    </div>

    <div v-loading="isLoading">
      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/internal/places"
          list-relative-path="places"
          list-item-component-name="InternalPlacesListItem"
          list-item-prop-name="place"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/internal/places"
        filter-relative-path="filters"
      />
    </div>

    <AddInternalPlaceDialog
      :is-open="isAddPlaceDialogOpen"
      @close="isAddPlaceDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import { placesTableColumns } from '@/components/Administration/Internal/Places/constants';
import AddInternalPlaceDialog from '@/components/Administration/Internal/Places/AddInternalPlaceDialog.vue';
import { mapState } from 'vuex';

export default {
  name: 'InternalPlacesV2',
  components: {
    AddInternalPlaceDialog,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddPlaceDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.internal.places.filters,
      isLoading: (state) => state.v2.admin.cms.internal.places.isLoading,
    }),
    columns() {
      return placesTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/internal/places/load');
    },
  },
};
</script>
